"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@mui/x-data-grid-pro/themeAugmentation");
const x_data_grid_pro_1 = require("@mui/x-data-grid-pro");
const TableRow_1 = require("@mui/material/TableRow");
const TablePagination_1 = require("@mui/material/TablePagination");
const MuiDataGridOverrides = {
    MuiDataGrid: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`.${x_data_grid_pro_1.gridClasses.columnSeparator}`]: { display: 'none' },
                [`.${x_data_grid_pro_1.gridClasses.row}`]: {
                    borderBottom: `1px solid ${theme.palette.gray[300]}`,
                    ':hover': { backgroundColor: theme.palette.gray[100] },
                    backgroundColor: theme.palette.common.white,
                },
                [`.${x_data_grid_pro_1.gridClasses.row}.${TableRow_1.tableRowClasses.selected}`]: { backgroundColor: theme.palette.blue[100] },
                [`.${x_data_grid_pro_1.gridClasses['row--lastVisible']}`]: { borderBottom: 'none' },
                [`.${x_data_grid_pro_1.gridClasses.columnHeaders}`]: {
                    borderBottom: `1px solid ${theme.palette.gray[300]}`,
                    backgroundColor: theme.palette.common.white,
                },
                [`.${x_data_grid_pro_1.gridClasses.cell}`]: {
                    color: theme.palette.gray[800],
                    ':focus': { outline: 'none' },
                    ':focus-within': { outline: 'none' },
                },
                [`.${x_data_grid_pro_1.gridClasses.columnHeader}`]: {
                    color: theme.palette.gray[900],
                    fontWeight: 600,
                    lineHeight: 1.5,
                    ':focus': { outline: 'none' },
                    ':focus-within': { outline: 'none' },
                },
                [`.${x_data_grid_pro_1.gridClasses.footerContainer}`]: { justifyContent: 'center' },
                [`.${x_data_grid_pro_1.gridClasses.footerContainer} .${TablePagination_1.tablePaginationClasses.root} .${TablePagination_1.tablePaginationClasses.toolbar}`]: {
                    border: 'none',
                },
                [`.${x_data_grid_pro_1.gridClasses['cell--withRightBorder']}`]: { borderRight: `1px solid ${theme.palette.gray[300]}` },
                [`.${x_data_grid_pro_1.gridClasses['columnHeader--withRightBorder']}`]: { borderRight: `1px solid ${theme.palette.gray[300]}` },
                [`.${x_data_grid_pro_1.gridClasses['cell--withLeftBorder']}`]: { borderLeft: `1px solid ${theme.palette.gray[300]}` },
                [`.${x_data_grid_pro_1.gridClasses['columnHeader--withLeftBorder']}`]: { borderLeft: `1px solid ${theme.palette.gray[300]}` },
                [`.${x_data_grid_pro_1.gridClasses['cell--pinnedLeft']}`]: { borderBottom: `1px solid ${theme.palette.gray[300]}` },
                [`.${x_data_grid_pro_1.gridClasses['cell--pinnedRight']}`]: { borderBottom: `1px solid ${theme.palette.gray[300]}` },
            }),
        },
    },
};
exports.default = MuiDataGridOverrides;
//# sourceMappingURL=MuiDataGridOverrides.js.map